import React from 'react';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { adminColors, adminRadii, adminTypography } from '../../../../styles/adminDesignTokens';
import { adminTableSx } from '../../../../styles/adminComponentStyles';
import type { StoreLocation } from '../../../../types/features/storeDetails/locations';

type StoreDetailsLocationsTableProps = {
  title: string;
  locations: StoreLocation[];
  onEditLocation: (location: StoreLocation) => void;
};

const StoreDetailsLocationsTable: React.FC<StoreDetailsLocationsTableProps> = ({
  title,
  locations,
  onEditLocation,
}) => {
  return (
    <Box sx={{ display: 'grid', gap: 1.25 }}>
      <Typography sx={{ ...adminTypography.bodyStrong, color: adminColors.primary, fontSize: 16, lineHeight: 1.35 }}>
        {title}
      </Typography>

      <TableContainer
        sx={{
          border: 'none',
          borderRadius: 0,
          overflowX: 'auto',
        }}
      >
        <Table
          size="small"
          aria-label={`${title} locations`}
          sx={{
            ...adminTableSx,
            minWidth: 520,
            '& .MuiTableCell-root': {
              padding: '8px 12px !important',
            },
          }}
        >
          <TableHead sx={{ '& th': { padding: '8px 12px !important', textTransform: 'uppercase' } }}>
            <TableRow>
              <TableCell sx={{ ...adminTypography.bodyStrong, color: adminColors.text, width: '48%' }}>
                Name
              </TableCell>
              <TableCell sx={{ ...adminTypography.bodyStrong, color: adminColors.text, width: '42%' }}>
                Key
              </TableCell>
              <TableCell sx={{ ...adminTypography.bodyStrong, color: adminColors.text, width: 92 }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations.map((location) => (
              <TableRow key={location.id} hover>
                <TableCell sx={{ ...adminTypography.body, color: adminColors.text }}>
                  {location.location_name}
                </TableCell>
                <TableCell sx={{ ...adminTypography.body, color: adminColors.text }}>
                  {location.location_key}
                </TableCell>
                <TableCell sx={{ ...adminTypography.body, color: adminColors.text }}>
                  <IconButton
                    aria-label={`Edit ${location.location_name}`}
                    size="small"
                    onClick={() => onEditLocation(location)}
                    sx={{
                      color: adminColors.primary,
                      borderRadius: adminRadii.sm,
                    }}
                  >
                    <EditRoundedIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default React.memo(StoreDetailsLocationsTable);
